// extracted by mini-css-extract-plugin
module.exports = {"outerbox":"input_outerbox__WD63O","box":"input_box__YgkVV","input":"input_input__8b4g3"};